import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadSubscribersEpicReducer } from "./LoadSubscribers.epics.js";
const subscriberDefaultReducerState = {
  items: getDefaultAsyncWrapperObj()
};
const subscriberReducer = (state = subscriberDefaultReducerState, action) => {
  state = loadSubscribersEpicReducer.reduxChange(state, action);
  return state;
};
const LoadSubscribersReducersMapObject = {
  subscribers: subscriberReducer
};
export {
  LoadSubscribersReducersMapObject,
  LoadSubscribersReducersMapObject as default,
  subscriberDefaultReducerState,
  subscriberReducer
};
//# sourceMappingURL=LoadSubscribers.ducks.js.map
